import useNotify, { NotificationDuration, NotificationEnums } from 'src/lib/useNotify';
import { logger } from 'src/services/logger/loggerService';

import { REACT_APP_PW_URL } from '../env';

const { showNotification } = useNotify();
export const WARNING_MESSAGE_IN_IE =
  'Please note that this website uses ES6 features that are not fully supported by Internet Explorer. For the best experience, we recommend using a modern browser like Chrome, Firefox, Edge, or Safari';
interface VideoUrlProps {
  scheduleId: string;
  batchSlug: string;
  topicSlug: string;
  playlist?: boolean;
  batchSubjectSlug: string;
}

export const getVideoUrl = (props: VideoUrlProps) => {
  const { scheduleId, batchSlug, topicSlug, batchSubjectSlug, playlist } = props;
  if (playlist) {
    return `/batches/${batchSlug}/${batchSubjectSlug}/${topicSlug}/content/${scheduleId}/true/video`;
  }
  return `/batches/${batchSlug}/${batchSubjectSlug}/${topicSlug}/content/${scheduleId}/video`;
};

export const secondsToTimestamp = (seconds: number) => {
  const _seconds = String(seconds % 60).padStart(2, '0');
  const _minutes = String(Math.floor(seconds / 60) % 60).padStart(2, '0');
  const _hours = String(Math.floor(seconds / (60 * 60))).padStart(2, '0');
  return `${_hours}:${_minutes}:${_seconds}`;
};

export const isSecondsGreaterThanTimestamp = (seconds: number, timestamp: string) => {
  const _seconds = seconds % 60;
  const _minutes = Math.floor(seconds / 60) % 60;
  const _hours = Math.floor(seconds / (60 * 60));
  return true;
};

export const currentSlideToSeconds = (seconds: number, slideTimestamps: string[]) => {
  let index = -1;
  for (let i = 0; i < slideTimestamps.length; i++) {
    if (parseInt(slideTimestamps[i]) > Math.floor(seconds)) {
      index = Math.max(i - 1, 0);
      break;
    }
  }
  return index;
};

export const changeVideoDurationIntoSec = (duration: string) => {
  let timeInSec = 0;

  const durationArray = duration?.split(':');

  if (durationArray?.length === 3) {
    timeInSec = +durationArray[0] * 3600 + +durationArray[1] * 60 + +durationArray[2];
  } else {
    timeInSec = +durationArray[0] * 60 + +durationArray[1];
  }

  return timeInSec;
};

export const sendCommandsToPlayer = (data: any) => {
  // @ts-ignore
  const videoPlayerContent = document.getElementById('pw-video-player')?.contentWindow; // @ts-ignore

  if (videoPlayerContent) videoPlayerContent.postMessage(data, '*');
};

export const redirectToPenpencilPlayer = (
  batchSlug: string,
  subjectSlug: string,
  scheduleId: string,
  dRoomId: string,
  batchSubjectId: string,
  playlistEnabled?: boolean,
  topicId?: string,
) => {
  if (playlistEnabled) {
    window.location.replace(
      `${REACT_APP_PW_URL}/batches/${batchSlug}/subjects/${subjectSlug}/subject-details/all/batch-video-player/k8?scheduleId=${scheduleId}&dRoom=${dRoomId}&batchSubjectId=${batchSubjectId}&topicId=${topicId}&cameFrom=k8`,
    );
    // window.open(
    //   `http://localhost:4200/batches/${batchSlug}/subjects/${subjectSlug}/subject-details/all/batch-video-player/k8?scheduleId=${scheduleId}&dRoom=${dRoomId}&batchSubjectId=${batchSubjectId}&topicId=${topicId}&cameFrom=k8`,
    //   '_blank'
    // )
    return;
  }
  window.location.replace(
    `${REACT_APP_PW_URL}/batches/${batchSlug}/subjects/${subjectSlug}/subject-details/all/batch-video-player/k8?scheduleId=${scheduleId}&dRoom=${dRoomId}&batchSubjectId=${batchSubjectId}&cameFrom=k8`,
  );
};

export const notSuitableForIE = () => {
  const isEdge = window.navigator.userAgent.indexOf('Edge') != -1;
  const isIE = window.navigator.userAgent.indexOf('Trident') != -1 && !isEdge;
  if (isIE) {
    showNotification({
      type: NotificationEnums.WARNING,
      duration: NotificationDuration.INFINITE,
      title: WARNING_MESSAGE_IN_IE,
    });
    return true;
  }
};
export const base64EncodeUint8Array = (input: any) => {
  const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  let output = '';
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;

  while (i < input.length) {
    chr1 = input[i++];
    chr2 = i < input.length ? input[i++] : Number.NaN;
    chr3 = i < input.length ? input[i++] : Number.NaN;

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
      enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
      enc4 = 64;
    }

    output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
  }
  return output;
};

export const base64DecodeUint8Array = (base64String: string): Uint8Array => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const base64EncodeUint8ArrayPallycon = (uint8Array: any): any => {
  let binaryString = '';
  for (let i = 0; i < uint8Array.length; i++) {
    binaryString += String.fromCharCode(uint8Array[i]);
  }
  return btoa(binaryString);
};

export const base64DecodeToUint8ArrayPallycon = (base64String: any): any => {
  const binaryString = atob(base64String);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const getContentIdPally = (emeOptions: any, initData: any): any => {
  console.log('getContentId function called with initData:', initData);
  const uri = initData;
  const pattern = 'skd://';
  const startIndex = uri.indexOf(pattern) + pattern.length;
  const assetId = uri.substring(startIndex);
  console.log('Extracted assetId: ' + assetId);
  return assetId;
};

type PlaybackHandlers = {
  onNotAllowedError?: (error: unknown) => void;
  onLoadOrPlaybackError?: (error: unknown) => void;
  onError?: (error: any) => void;
  onPlaybackStart?: () => void;
};

export const requestPlayback = (
  player: any,
  { onNotAllowedError, onLoadOrPlaybackError, onPlaybackStart, onError }: PlaybackHandlers = {},
) => {
  const startPlayPromise = player?.play() as Promise<unknown> | undefined;
  if (startPlayPromise !== undefined) {
    startPlayPromise
      .then(() => {
        onPlaybackStart?.();
      })
      .catch((error) => {
        logger.warn('Play failed:', { errorName: error?.name, errorMessage: error?.message });
        onError?.(error);
        if (error.name === 'NotAllowedError') {
          onNotAllowedError?.(error);
        } else {
          onLoadOrPlaybackError?.(error);
        }
      });
  }
};

export const requestPlayerDispose = (player: any) => {
  // Adding a check to not call dispose again if the player is already disposed.
  // Dispose removed the dom node and calling it twice would result into element not found errors.
  if (player && !player.isDisposed()) {
    player.dispose();
  }
};
